export default __webpack_public_path__ + "static/media/Group1455.d83e2308.svg";